// extracted by mini-css-extract-plugin
module.exports = {"bottom_menu":"BottomMenu_bottom_menu__2a--G","menu_item":"BottomMenu_menu_item__1sSZm","menu_item_selected":"BottomMenu_menu_item_selected__uagTI"};